import { useState } from "react";
import { AppProvider, useApp } from "./context/AppContext";
import Login from "./pages/Login";
import Sidebar from "./components/Sidebar";
import Dashboard from "./pages/Dashboard";
import Patients from "./pages/Patients";
import Settings from "./pages/Settings";
import Imaging from "./pages/Imaging";
import SystemStatus from "./pages/SystemStatus";
import LabReports from "./pages/LabReports";
import "./index.css";

// Role-based page access map
const ROLE_PAGES = {
  admin:        ["dashboard","patients","reports","imaging","settings","system"],
  doctor:       ["dashboard","patients","reports","imaging"],
  technician:   ["dashboard","patients","reports","imaging"],
  receptionist: ["dashboard","patients"],
};

function Shell() {
  const { user, backendOk } = useApp();
  const [active, setActive]                     = useState(() => sessionStorage.getItem("emr_active_page") || "dashboard");
  const [selectedPatient, setSelectedPatient]   = useState(() => sessionStorage.getItem("emr_selected_patient") || null);

  if (!user) return <Login />;

  const allowed = ROLE_PAGES[user.role] || ["dashboard"];

  const handleSetActive = (page) => {
    if (!allowed.includes(page)) return;
    // Always clear report/patient navigation state when switching tabs
    ["emr_pd_view","emr_pd_type","emr_pd_rep","emr_pd_param","emr_selected_patient"].forEach(k => sessionStorage.removeItem(k));
    setSelectedPatient(null);
    setActive(page);
    sessionStorage.setItem("emr_active_page", page);
  };

  const handleSetSelectedPatient = (id) => {
    setSelectedPatient(id);
    if (id) sessionStorage.setItem("emr_selected_patient", id);
    else sessionStorage.removeItem("emr_selected_patient");
  };

  const safeActive = allowed.includes(active) ? active : "dashboard";

  return (
    <div className="app-shell">
      <Sidebar active={safeActive} setActive={handleSetActive} />
      <div className="main-content">

        {/* Topbar */}
        <div className="topbar">
          <div style={{ flex:1, display:"flex", alignItems:"center", gap:10 }}>
            <div style={{ fontSize:15, fontWeight:700, color:"#0F172A", textTransform:"capitalize", letterSpacing:"-0.2px" }}>
              {safeActive === "reports" ? "Lab Register" : safeActive.charAt(0).toUpperCase() + safeActive.slice(1)}
            </div>
            {backendOk === false && (
              <span className="badge badge-red" style={{fontSize:11}}>● Offline</span>
            )}
            {backendOk === true && (
              <span style={{ fontSize:11, color:"#16A34A", fontWeight:600, display:"flex", alignItems:"center", gap:4 }}>
                <span style={{ width:6, height:6, borderRadius:"50%", background:"#16A34A", display:"inline-block" }}></span>
                Live
              </span>
            )}
          </div>
          <div style={{ fontSize:12, color:"#94A3B8", fontWeight:500 }}>
            {new Date().toLocaleDateString("en-GB", { weekday:"long", year:"numeric", month:"long", day:"numeric" })}
          </div>
        </div>

        {/* Page body */}
        <div className="page-body">
          {safeActive === "dashboard" && (
            <Dashboard setActive={handleSetActive} setSelectedPatient={handleSetSelectedPatient} />
          )}
          {safeActive === "patients" && (
            <Patients
              selectedPatient={selectedPatient}
              setSelectedPatient={handleSetSelectedPatient}
            />
          )}
          {safeActive === "reports" && <LabReports />}
          {safeActive === "imaging" && <Imaging />}
          {safeActive === "settings" && user.role === "admin" && <Settings />}
        {safeActive === "system" && user.role === "admin" && <SystemStatus />}
        </div>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <AppProvider>
      <Shell />
    </AppProvider>
  );
}